import { useMemoizedFn } from 'ahooks';
import useConfigureTexts from '@intelligence/hooks/useConfigureTexts';

export default function useRadioOptionsTipsGetterOfRegionSelect(enable = true) {
  const { configureTexts } = useConfigureTexts();

  const getRadioOptionsTips = useMemoizedFn(() => {
    return { ...configureTexts };
  });

  return !enable ? undefined : getRadioOptionsTips;
}
